import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ConfirmationService} from 'primeng/api';
import {Subscription} from 'rxjs';
import {ActivatedRoute} from '@angular/router';
import {ObjectBaseComponent} from '../../../../../core/shared/object/mvs-object-base/object-base.component';
import {MvsCoreService} from '../../../../../core/shared/service/mvs-core.service';
import {MvsMessageService} from '../../../../../core/shared/service/message/mvs-message.service';
import {ObserverService} from '../../../../../core/shared/object/service/observer.service';
import {NavigationItem} from '../../../../../core/shared/dto/navigation/navigation-item';
import {WidgetData} from '../../../../../core/shared/widget/widget-data';
import {WidgetFactory} from '../../../../../core/shared/widget/service/widget.factory';
import {FilterCriteria} from '../../../../../core/shared/filter/api/filter.criteria';
import {
    WidgetFunctionCallBackCreate,
    WidgetToolbarCreateInterface
} from '../../../../../core/shared/helper/widget-function-call-back-create';
import {UfFlowTypeStepDto} from '../../../model/dto/entity/uf-flow-type-step.dto';

@Component({
    selector: 'uf-flow-type-step-object-component',
    templateUrl: 'uf-flow-type-step-object.component.html',
    styleUrls: ['uf-flow-type-step-object.component.scss'],
    standalone: false
})
export class UfFlowTypeStepObjectComponent extends ObjectBaseComponent implements OnInit, OnChanges, OnDestroy {

    dto: UfFlowTypeStepDto;

    activitiesWidget: WidgetData;
    actionsWidget: WidgetData;
    topicRulesWidget: WidgetData;

    navigationItems: NavigationItem[] = [
        {
            label: 'Übersicht',
            action: 'overview',
            tooltip: 'Übersicht des Schritts',
            icon: 'fa-regular fa-eye',
            toggleable: false,
            default: true
        },
        {
            label: 'Aktivitäten',
            action: 'activities',
            tooltip: 'Aktivitäten des Schritts',
            icon: 'fa-regular fa-list-check',
            toggleable: false,
            default: false
        },
        {
            label: 'Aktionen',
            action: 'actions',
            tooltip: 'Aktionen des Schritts',
            icon: 'fa-regular fa-bolt',
            toggleable: false,
            default: false
        },
        {
            label: 'Themenregeln',
            action: 'topicRules',
            tooltip: 'Themenregeln des Schritts',
            icon: 'fa-regular fa-scale-balanced',
            toggleable: false,
            default: false
        }
    ];

    private queryParamSubscription: Subscription;

    constructor(
        protected coreService: MvsCoreService,
        protected messageService: MvsMessageService,
        protected confirmationService: ConfirmationService,
        protected override observerService: ObserverService,
        private route: ActivatedRoute
    ) {
        super(coreService, messageService, confirmationService, observerService);
    }

    ngOnInit() {
        super.ngOnInit();
        this.subscribeToNavItemQueryParam();
    }

    onObjectChanged() {
        if (!this.activeNavigationItems) {
            this.activeNavigationItems = this.navigationItems[0];
        }
        this.onNavigationItems.emit(this.navigationItems);
        this.createChildWidgets();
    }

    private subscribeToNavItemQueryParam(): void {
        this.queryParamSubscription = this.route.queryParams.subscribe(params => {
            const navItem = params['navItem'];
            if (navItem) {
                const found = this.navigationItems.find(item => item.action === navItem);
                if (found) {
                    this.activeNavigationItems = found;
                }
            }
        });
    }

    private createChildWidgets(): void {
        const stepId = this.objectIdentifier.objectId;

        // --- Activities Widget ---
        const activitiesFilter = [
            FilterCriteria.create('e.flowTypeStepId', FilterCriteria.cOperatorEqual, stepId)
        ];
        this.activitiesWidget = WidgetFactory.createWidgetTableEntityFkeyResolveQl(
            'uf.flowTypeStep.object.activities.table',
            'Aktivitäten',
            'uf.UfFlowTypeStepActivity',
            activitiesFilter
        );
        const activitiesCreateFields: WidgetToolbarCreateInterface[] = [
            {fieldName: 'flowTypeStepId', fieldValue: stepId}
        ];
        this.activitiesWidget.functionCallbacks = WidgetFunctionCallBackCreate.widgetToolbarCreate(activitiesCreateFields);

        // --- Actions Widget ---
        const actionsFilter = [
            FilterCriteria.create('e.flowTypeStepId', FilterCriteria.cOperatorEqual, stepId)
        ];
        this.actionsWidget = WidgetFactory.createWidgetTableEntityFkeyResolveQl(
            'uf.flowTypeStep.object.actions.table',
            'Aktionen',
            'uf.UfFlowTypeStepAction',
            actionsFilter
        );
        const actionsCreateFields: WidgetToolbarCreateInterface[] = [
            {fieldName: 'flowTypeStepId', fieldValue: stepId}
        ];
        this.actionsWidget.functionCallbacks = WidgetFunctionCallBackCreate.widgetToolbarCreate(actionsCreateFields);

        // --- Topic Rules Widget ---
        const topicRulesFilter = [
            FilterCriteria.create('e.flowTypeStepId', FilterCriteria.cOperatorEqual, stepId)
        ];
        this.topicRulesWidget = WidgetFactory.createWidgetTableEntityFkeyResolveQl(
            'uf.flowTypeStep.object.topicRules.table',
            'Themenregeln',
            'uf.UfFlowTypeStepTopicRule',
            topicRulesFilter
        );
        const topicRulesCreateFields: WidgetToolbarCreateInterface[] = [
            {fieldName: 'flowTypeStepId', fieldValue: stepId}
        ];
        this.topicRulesWidget.functionCallbacks = WidgetFunctionCallBackCreate.widgetToolbarCreate(topicRulesCreateFields);
    }

    ngOnChanges(changes: SimpleChanges) {
        super.ngOnChanges(changes);
    }

    ngOnDestroy() {
        super.ngOnDestroy();
        this.queryParamSubscription?.unsubscribe();
    }
}
